import React from "react";
import './styles/covid.css';
import wabes from './styles//images/download.svg';
import CovidFAQ from "./CovidFaqs";
import Footer from "./Footer";
function Covid(){

    return(
        <>
       <section id="about3" className="about">
      {/* Background Video */}
      <video autoPlay loop muted playsInline id="background-video">
        <source src="video/covid-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 pb-5" id="about-col1">
            <h1 className="heading">

            <span className="hero-highlight">COVID-19:</span>  <br />
            Stay<span className="hero-highlight"> Informed</span>, Stay <span className="hero-highlight">Safe</span>
            </h1>
            <p className="supporting">
            Find out where to get tested and how to stay protected
            </p>
          </div>
        </div>
      </div>
      <img src={wabes} alt="Waves" id="waves1" />
    </section>
      <section className="section">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <h1 className="text-left pb-3">
                      Is it <span className="hero-highlight">COVID-19</span> 
                    </h1>
                    <ul>
                        <li>
                            Shortness of breath or difficulty breathing
                        </li>
                        <li>
                            Cough
                        </li>
                    </ul>
                    <h5 className="mt-4 mb-5">
                    Symptoms of COVID-19 can include cough, shortness of breath, fever, chills, headache, muscle pain, sore throat, or loss of taste or smell. Other less common symptoms include gastrointestinal symptoms like nausea, vomiting, or diarrhea. These symptoms may appear 2-14 days after you are exposed to the virus that causes COVID-19. Not everyone with COVID-19 has all of these symptoms, and some people may not have any symptoms.
                    </h5>
                    <h1>
                    Should I Get Tested for <span className="hero-highlight">COVID-19</span>?
                    </h1>
                    <p className="mt-3">
                    Our online screening tool assists with identifying Minnesotans who should be tested for COVID-19. Click the button below to determine if you should be tested.
                    </p>
                    <a href="https://www.health.state.mn.us/diseases/covid-19/testing.html">
                        <button className="btn btn-primary" id="test-button">Get Tested</button>
                    </a>
                    <h1 className="mt-5">
                    What To Do If You Are <span className="hero-highlight">Sick</span>
                    </h1>
                    <p className="mt-3">
                    If you have symptoms of COVID-19, you should:
                    </p>
                    <ul className="mt-3">
                        <li className="p-2">
                            Stay Home
                        </li>
                        <li className="p-2">
                        Wash your hands often.
                        </li>
                        <li className="p-2">
                        Cover your coughs and sneezes.
                        </li>
                        <li className="p-2">
                        Avoid sharing personal household items like dishes, towels, bedding, etc.
                        </li>
                        <li className="p-2">
                        Clean surfaces that you touch often.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
            <CovidFAQ/>
            </div>
        </div>
      </section>
      <footer>
        <Footer />
      </footer>
        </>
    )
}
export default Covid;